export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'

  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: { accessToken },
      } = store.getState()

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )

  const APP_ENV = process.env.REACT_APP_ENV
  if (APP_ENV !== "development") {
    axios.interceptors.response.use(
      (response: any) => response,
      (error: any) => {
        const { config, response, message, request } = error

        const dataUser = (localStorage.getItem("persist:v100-demo1-auth") && JSON.parse(localStorage.getItem("persist:v100-demo1-auth")!).user) ? JSON.parse(JSON.parse(localStorage.getItem("persist:v100-demo1-auth")!).user) : ""
        const dataVersion = localStorage.getItem("version-crm")

        if (!urlNotAllowList().some(disallowed => config?.url?.includes(disallowed))) {
          let url = config?.url
          let method = config?.method?.toUpperCase()
          let requestHeaders = config?.headers
          let requestBody = config?.data ? JSON.parse(config?.data) : ""
          let pathName = window.location.pathname

          if (response) {
            if (pathName === "/chat" && response?.status === 401) {
              closeAndDeleteDatabase("chat-database")
            } else if (pathName !== "/auth" && response?.status === 401 && !url.includes("wzcorp/verify_token")) {
              localStorage.removeItem("persist:v100-demo1-auth")
              window.location.href = "/"
            }

            let responseData = response?.data
            apiSendDiscord(url, method, dataUser?.data?.username, {
              header: requestHeaders,
              body: requestBody,
              response: responseData,
              code: response?.status,
              version: dataVersion
            })
          } else {
            let messageData = message
            apiSendDiscord(url, method, dataUser?.data?.username, {
              header: requestHeaders,
              body: requestBody,
              response: messageData,
              code: request?.status,
              version: dataVersion
            })
          }
        }

        return Promise.reject(error)
      }
    )
  }
}

const DISCORD_URL = "https://discord.com/api/webhooks/1359339958401237116/cv7S-ilL_QbZs2hV-7MaTVuArAoPRBupChWD2cv4fmgfZhLdET81tbUTMS6pZciOD3it";
async function apiSendDiscord(endpoint: string, method: string, username: string, body: any) {
  const prettyBody = JSON.stringify(body, null, 2); // format biar lebih mudah dibaca

  try {
    const response = await fetch(DISCORD_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: "Wooblazz CRM",
        avatar_url: "https://www.wooblazz.com/logo-wooblazz.png",
        content: `[Website] Error telah terjadi di username \`${username}\` endpoint \`${endpoint}\` method \`${method}\`!`,
        embeds: [
          {
            description: `**Payload:**\n\`\`\`json\n${prettyBody}\n\`\`\``,
            timestamp: new Date().toISOString(),
          },
        ],
      }),
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }
  } catch (error) {
    console.error("Error sending to Discord:", error);
  }
}

function closeAndDeleteDatabase(dbName: string) {
  const request = indexedDB.open(dbName);

  request.onsuccess = function () {
    const db = request.result;
    db.close();

    const deleteRequest = indexedDB.deleteDatabase(dbName);

    deleteRequest.onsuccess = function () {
      window.location.href = "/chat";
    };

    deleteRequest.onerror = function () {
      window.location.href = "/chat";
    };

    deleteRequest.onblocked = function () {
      window.location.href = "/chat";
    };
  };

  request.onerror = function () {
    window.location.href = "/chat";
  };
}

function urlNotAllowList() {
  return [
    'https://tool.looyal.id/face/check-data'
  ]
}